
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12 24c-4.254 0-6.417-1.197-7.484-2.208a4.304 4.304 0 01-.64-.752C3.127 19.917 1.466 8.53.785 3.67a1.342 1.342 0 01-.028-.199.57.57 0 01-.007-.096C.75.711 7.822 0 12 0s11.25.711 11.25 3.375c0 .035-.002.07-.007.104a1.31 1.31 0 01-.027.191c-.533 3.801-2.32 16.212-3.092 17.37a4.294 4.294 0 01-.645.755C18.418 22.802 16.256 24 12 24zm-5.863-2.826c.759.504 2.038 1.05 4.131 1.248l.672-.672-2.689-2.69-2.114 2.114zm7.596 1.247c2.093-.198 3.372-.744 4.131-1.248L15.75 19.06l-2.689 2.689.672.672zm-1.732-1.732L14.69 18 12 15.31l-2.689 2.689 2.69 2.69zm-7.849-5.03c.56 3.212.822 4.167.928 4.451L7.19 18l-2.689-2.69-.349.349zm14.768 4.45c.106-.285.369-1.242.928-4.451l-.348-.348L16.811 18l2.109 2.109zm-3.17-3.17l2.689-2.689-2.689-2.69-2.689 2.689 2.689 2.69zm-7.499 0l2.689-2.689-2.689-2.69-2.689 2.689 2.689 2.69zm11.249-3.75l.91-.91c.311-1.94.648-4.153.967-6.345L16.811 10.5l2.689 2.689zm-7.5 0l2.69-2.689L12 7.81 9.311 10.5 12 13.189zm-7.499-.001L7.19 10.5 2.622 5.932c.319 2.194.656 4.407.967 6.345l.912.911zm3.75-3.749L10.94 6.75l-.013-.013c-2.244-.057-4.359-.29-6.037-.658l3.361 3.36zm7.499 0l3.36-3.36c-1.677.368-3.792.601-6.036.657l-.013.014 2.689 2.689zM2.26 3.396C2.495 3.943 5.635 5.25 12 5.25c6.362 0 9.503-1.307 9.74-1.854l.006-.041C21.578 2.784 18.162 1.5 12 1.5c-6.16 0-9.576 1.283-9.745 1.856l.005.04z"}})])
          )
        }
      }
    